import React, { useState } from "react";
import Typography from "@mui/material/Typography";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import LinearProgress from "@mui/material/LinearProgress";
import CheckIcon from "@mui/icons-material/Check";
import PublishIcon from '@mui/icons-material/Publish'
import { useUploadForm } from "./hooks";
import  ExcelAnalysis  from "./ExcelAnalysis";
import configData from "./config.json";
const { AzureOpenAI } = require("openai");


const SERVER_URL=configData.SERVER_URL

const azureOpenAIKey = '9fb5af1332a648b1bba4198731e389bd';
const azureOpenAIEndpoint = 'https://pragyaaGPT4.openai.azure.com/';
const azureOpenAIVersion = "2024-05-01-preview";

const getClient = () => {
    const assistantsClient = new AzureOpenAI({
        endpoint: azureOpenAIEndpoint,
        apiVersion: azureOpenAIVersion,
        apiKey: azureOpenAIKey,
		dangerouslyAllowBrowser: true,
    });
    return assistantsClient;
};


const Form = () => {
  const [formValues, setFormValues] = useState({
    file: null,
  });


  const { isSuccess, uploadForm, progress } = useUploadForm(
    //SERVER_URL.includes('localhost')?SERVER_URL+"/upload":SERVER_URL+(formValues.processType.includes('raw')?'color':formValues.processType)+"/upload"
    SERVER_URL+"/upload"
  );

  const handleFileChange = (event) => {
    setFormValues((prevFormValues) => ({
      ...prevFormValues,
      file: event.target.files ? event.target.files[0] : null,
    }));
  };

  const handleSubmit = async () => {
    const formData = new FormData();
    formValues.file && formData.append("file", formValues.file);
    formValues.file && formData.append("filename", formValues.file.name);
	var assistantsClient=getClient();
	const uint8array = formValues.file;
	/*
	const uploadAssistantFile = await assistantsClient.files.create({
	      file: uint8array,
	      purpose: "assistants",
	    });
	*/
	//const uploadAssistantFile = await assistantsClient.uploadFile(uint8array, "assistants", { filename });
	//var batch_add = assistantsClient.beta.vector_stores.file_batches.create({
	assistantsClient.beta.vectorStores.fileBatches.uploadAndPoll(
	  "vs_grT7QrdJ6naN8k80m3mMIZ1R",
	  //file_ids:[uploadAssistantFile.id]
		 {  files: [uint8array] },
	)
	
    return await uploadForm(formData);
  };

  return (
    <Box
      display="flex"
      height="100%"
      flexDirection="column"
      justifyContent="center"
      alignItems="center"
    >
	  <Box marginY={1}>
		  <Typography variant="h4" color="primary">
	          pragyaa.ai AIChat App
	      </Typography>
	  </Box>

      <Box marginY={1} className="hide">
      <Button variant="contained" component="label" disabled={isSuccess}>
        {formValues.file?.name ?? "Select File"}
        <input type="file" onChange={handleFileChange} accept=".xlsx, .xls, .csv, .doc, .docx, .pdf" hidden />
      </Button>
        {isSuccess ? (
          <>
            <CheckIcon color="success" />
          </>
        ) : (
          <>
            <Button startIcon={<PublishIcon />} size="large" onClick={handleSubmit}>Upload</Button>
            <LinearProgress variant="determinate" value={progress} />
          </>
        )}
      </Box>

	  <Box marginY={1}>
		      <ExcelAnalysis />
	  </Box>
    </Box>
  );
};

export default Form;